import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { AdministratorModeActionsUnion, AdministratorModeActionTypes, AdministratorModeStateModel } from "../actions/administrator-mode.actions";

// This adapter will allow is to manipulate VesselCallManagement
export const adapter = createEntityAdapter<AdministratorModeStateModel>({
    selectId: (administratorMode: AdministratorModeStateModel) =>
        buildSelectId('global'),
    sortComparer: false
});


export interface State extends EntityState<AdministratorModeStateModel> {
    selectedEntityId: string | null
}

export const INIT_STATE: State = adapter.getInitialState({
    selectedEntityId: null,
});

export function reducer(state: State = INIT_STATE, action: AdministratorModeActionsUnion) {
    switch (action.type) {

        case AdministratorModeActionTypes.LOAD_MENU_ADMIN_SUCCESS: {
            const selectedId = buildSelectId('global');
            return adapter.upsertOne({
                menuItems: action.menuItems,
                isAdmin: true
            } as AdministratorModeStateModel, {
                ...state,
                selectedEntityId: selectedId
            });
        }
        case AdministratorModeActionTypes.LOAD_MENU_REGULAR_SUCCESS: {
            const selectedId = buildSelectId('global');
            return adapter.upsertOne({
                menuItems: action.menuItems,
                isAdmin: false
            } as AdministratorModeStateModel, {
                ...state,
                selectedEntityId: selectedId
            });
        }

        case AdministratorModeActionTypes.DELETE_MENU: {
          const selectedId = buildSelectId('global');
          return adapter.upsertOne({
              menuItems: null
          } as AdministratorModeStateModel, {
              ...state,
              selectedEntityId: selectedId
          });
        }

        default:
            return state;
    }
}

export function buildSelectId(id: string): string {
    return `${id || 'new'}`;
}

export const getEntities = (state: State) => state ? state.entities : null;
